export default {
	path: 'reports/:reportId',
	name: 'Report',
	component: () => import('@/views/report/Index'),
	meta: {
		dynamic: true,
	},
	children: [
		{
			path: 'overview',
			name: 'ReportOverview',
			component: () => import('@/views/report/ReportOverview'),
			meta: {
				title: 'Overview',
			},
		},
		{
			path: 'articles',
			name: 'ArticlesList',
			component: () => import('@/views/report/ArticlesList'),
			meta: {
				title: 'Articles',
			},
		},
		{
			path: 'archive',
			name: 'ArchiveList',
			component: () => import('@/views/report/ArchiveList'),
			meta: {
				title: 'Archive',
			},
		},
		{
			path: 'publications',
			name: 'ReportPublications',
			component: () => import('@/views/report/ReportPublications'),
			meta: {
				title: 'Publications',
			},
		},
		{
			path: 'issues',
			name: 'ReportIssues',
			component: () => import('@/views/report/ReportIssues'),
			meta: {
				title: 'Issues',
			},
		},
		{
			path: 'settings',
			name: 'ReportSettings',
			component: () => import('@/views/report/Settings'),
			meta: {
				title: 'Settings',
			},
		},
	],
};
